// extracted by mini-css-extract-plugin
export const root = "section-menu-module--root--m05v7";
export const scrollingUp = "section-menu-module--scrollingUp--1_BAI";
export const listItem = "section-menu-module--listItem--1KJPG";
export const isSelected = "section-menu-module--isSelected--2Ys9Z";